import { asArray } from './parser.array.js';
import { asBoolean } from './parser.boolean.js';
import { asEnum } from './parser.enum.js';
import { asNumber } from './parser.number.js';
import { asString } from './parser.string.js';
import { environment, serializePublicEnvironment } from './util.environment.js';

const configFromEnv = Object.freeze({
  asString,
  asNumber,
  asBoolean,
  asEnum,
  asArray,
  serializePublicEnvironment,
  __override: environment.override
});

export { configFromEnv };
//# sourceMappingURL=index.js.map
